import { createApp } from 'vue';
import TgsToApngConverter from '@/Components/TgsToApngConverter.vue';
import '@styles/app.css';

createApp(TgsToApngConverter).mount('#tgs-to-apng-converter');
